import { Box, Menu } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";

import { QuickCheckStatus, STATUS_COLORS } from "./types";

interface StatusIndicatorProps {
  status: QuickCheckStatus | null;
  size?: number;
  withDropdown?: boolean;
  onStatusChange?: (status: QuickCheckStatus) => void;
}

const STATUS_OPTIONS: QuickCheckStatus[] = ["GREEN", "YELLOW", "RED"];

const StatusIndicator = ({
  status,
  size = 12,
  withDropdown = false,
  onStatusChange,
}: StatusIndicatorProps) => {
  // Ako nema statusa (null), prikaži NONE boju
  const colorKey = status || "NONE";

  const dotStyle = {
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: STATUS_COLORS[colorKey],
    display: "inline-block",
  };

  if (!withDropdown) {
    return <Box style={dotStyle} />;
  }

  return (
    <Menu shadow="md" width={120}>
      <Menu.Target>
        <Box
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: 4,
            border: "1px solid var(--mantine-color-gray-3)",
          }}
        >
          <Box style={dotStyle} />
          <IconChevronDown size={14} color="var(--mantine-color-gray-6)" />
        </Box>
      </Menu.Target>

      <Menu.Dropdown>
        {STATUS_OPTIONS.map((option) => (
          <Menu.Item
            key={option}
            onClick={() => onStatusChange?.(option)}
            leftSection={
              <Box
                style={{
                  width: size,
                  height: size,
                  borderRadius: "50%",
                  backgroundColor: STATUS_COLORS[option],
                }}
              />
            }
          >
            {option === status && "✓"}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default StatusIndicator;
